<vsn-navigation [lang]="vsnLang()" [auth]="vsnAuth()" [tree]="vsnTree()" [showHelp]="true" [notificationActive]="isNotificationActive()"
    [showNotification]="true" [helpUrl]="vsnHelpUrl()" [landingPageUrl]="vsnLandingPageUrl()" [modules]="vsnModules()"
    [feedback]="vsnFeedback()">

    <div slot="context-selector">
        <adminui-autocomplete class="adminui-autocomplete--lg" [suggestions]="contextGroups()" [(ngModel)]="selectedContext" [group]="true"
            (completeMethod)="onSearchContext($event)" (selected)="onSelectContext($event)" (blurred)="onBlurContext()"
            [dropdown]="true" [placeholder]="message()['searchByName']" [aria-label]="message()['searchByName']"
            [minQueryLength]="3" optionLabel="name" [emptyMessage]="message()['noResultsFound']" (focused)="onFocus($event)">
            <ng-template adminuiAutocompleteGroup let-group>
                @if(group.type !== 'none'){
                <div class="group-label"><span>{{group.label}}</span></div>
                }
            </ng-template>
        </adminui-autocomplete>
    </div>

    <ng-content></ng-content>

    <div class="assistant-popover-container" [attr.data-open]="isGaiaChatOpen()">
        <!-- Named because this is the second complementary landmark in the shell (the notification
             drawer below is the other), and same-role landmarks need distinguishing names
             (Web:S5255). The gaiaAssistantAriaLabel key was already present and translated in all 7
             locales but used nowhere - this is what it was for. -->
        <aside id="chatDrawer" [attr.aria-label]="message()['gaiaAssistantAriaLabel']">
            <gaia-chat id="assistant" #gaiaChat [attr.profile-id]="profileId()" [attr.base-url]="baseUrl()"
                [attr.lang]="lang()" auth-strategy="visma" closeable>
            </gaia-chat>
        </aside>
    </div>

    <div class="notification-panel-popover-container" [attr.data-open]="isNotificationPanelOpen()">
        @if (isNotificationPanelOpen()) {
        <aside class="notification-panel-drawer" role="dialog"
            [attr.aria-label]="message()['headerNotifications'] || 'Notifications'" tabindex="-1">
            <adminui-latest-export [message]="message()"></adminui-latest-export>
        </aside>
        }
    </div>

</vsn-navigation>
